import { Box, Flex, HStack, Select, Table, TableContainer, Tbody, Text, Th, Thead, Tr, useDisclosure } from '@chakra-ui/react'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import AttachmentModal from '../Components/AttachmentModal'
import Pagination from '../Components/Pagination'
import PendingIQA from '../Components/PendingIQA'
import Preloader from '../Components/Preloader'
import TableRow from '../Components/TableRow'
import MainLayout from '../Layouts/Index'
import { GetAllInspectedSra, GetAllPendingSRA, GetAllSRA } from '../Utils/ApiCalls'
import Seo from '../Utils/Seo'
import { configuration } from '../Utils/config'
import SearchComponent from '../Components/SearchComponent'

export default function InventoryAccount() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [SraID, setSraID] = useState("");
  const [OpenModal, setOpenModal] = useState(false);
  const [SIngleData, setSIngleData] = useState([]);
  const [SearchText, setSearchText] = useState("");
  const [StoreType, setStoreType] = useState("");


  const [Data, setData] = useState([]);
  const [CurrentPage, setCurrentPage] = useState(1);
  const [PostperPage, setPostperPage] = useState(configuration.sizeperpage);
  const [PreLoader, setPreLoader] = useState(true);


  //get current post

  const indexOfLastSra = CurrentPage * PostperPage;
  const indexOfFirstSra = indexOfLastSra - PostperPage;
  const currentData = Data.slice(indexOfFirstSra, indexOfLastSra);

  console.log("currentData", currentData)
  //change page 
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber)
  }

  const openSra = (id) => {
    onOpen()
    setSraID(id)
  }

  const ViewAttachment = (id) => {
    let singleData = Data.filter(item => item._id === id)
    setSIngleData(singleData)
    setOpenModal(true)

  }



  const AllSRA = async () => {
    let result = await GetAllInspectedSra()

    console.log("inspected Sra", result);

    if (result.status == true) {
      setData(result.queryresult.sraproductdetails
      )
      setPreLoader(false)
    }
  }

  useEffect(() => {
    AllSRA()

  }, [isOpen]);
  return (
    <MainLayout>
      {
        PreLoader && (

          <Preloader />
        )
      }
      <Seo title="Inventory Account" description='IMS Inventory Account ' />

      <Flex justifyContent={"flex-end"} flexWrap="wrap" fontWeight={"500"}>


        <Text textTransform="Capitalize" >Total Inspected SRA- {Data?.length}</Text>
      </Flex>

      <Flex justifyContent={"space-between"} flexWrap="wrap" alignItems={"flex-start"}>
        <Box w={["100%", "100%", "100%", "100%", "48%"]}>

          <SearchComponent SearchText={SearchText} setSearchText={(e) => setSearchText(e.target.value)} Keywords={"productName, ProductShelfId"} />
        </Box>

        <Box w={["100%", "100%", "100%", "100%", "48%"]}>

          <Text mt="-10px" fontSize={""}>Filter by Store</Text>

          <Select borderColor={"#000"} color={"#000"} placeholder='Select Store' _focus={{ borderColor: "blue.blue400" }} fontWeight={"400"} fontSize={StoreType != "" ? "16px" : "12px"} id='store' value={StoreType} onChange={(e) => setStoreType(e.target.value)}>

            <option value="1" >Admin Store Marina</option>
            <option value="2" >Central Circle stores, Ijora</option>
            <option value="3" >East Circle stores, Island</option>
            <option value="4" >West Circle stores, Festac</option>

          </Select>
        </Box>
      </Flex>

      <Box display={"block"} alignItems="flex-start" w={"100%"} height="70vh" minH={"70vh"} overflow="auto" _hover={{ overflow: "auto" }} bg="blue.blue200" mt="32px" rounded={"8px"}>

        <TableContainer w={"100%"} mt="32px" overflowX="auto" color="#fff"

        >
          <Table variant='simple' size='sm' overflowX="auto" >
            <Thead>
              <Tr>
                <Th color="#fff">S/N</Th>
                <Th color="#fff">Product Name</Th>
                <Th color="#fff"> Product shelf id</Th>
                <Th color="#fff"> Store</Th>
                <Th color="#fff">Qty inspected</Th>
                <Th color="#fff">Qty Certified</Th>
                <Th color="#fff">See Attachment</Th>
                <Th color="#fff">Action</Th>

              </Tr>
            </Thead>
            <Tbody>

            
              {
                SearchText === "" && StoreType === "" ? (
                  currentData.map((item, i) => (
                    <TableRow
                      type="inspectedSra"
                      sn={i + 1}
                      productName={item.shelfid?.productname}
                      productShelfId={item.shelfid?.productshelfid}
                      store={item.store}
                      qtyinspected={item.qtyinspected}
                      dateReceived={item.qtycertified}
                      onClick={() => openSra(item._id)}
                      viewAtt={() => ViewAttachment(item._id)}

                    />
                  ))
                ) : (
                  SearchText !== "" && Data.filter(item => item.shelfid?.productname.toLowerCase().includes(SearchText.toLowerCase()) || item.shelfid?.productshelfid.includes(SearchText)).length > 0 ? (
                    Data.filter(item => item.shelfid?.productname.toLowerCase().includes(SearchText.toLowerCase()) || item.shelfid?.productshelfid.includes(SearchText)  || item.store === StoreType)
                      .map((item, i) => (
                        <TableRow
                          type="inspectedSra"
                          sn={i + 1}
                          productName={item.shelfid?.productname}
                          productShelfId={item.shelfid?.productshelfid}
                          store={item.store}
                          qtyinspected={item.qtyinspected}
                          dateReceived={item.qtycertified}
                          onClick={() => openSra(item._id)}
                          viewAtt={() => ViewAttachment(item._id)}

                        />
                      ))
                  ) : (

                    StoreType !== "" ? (
                      Data.filter(item => item.store === StoreType)
                        .map((item, i) => (
                          <TableRow
                            type="inspectedSra"
                            sn={i + 1}
                            productName={item.shelfid?.productname}
                            productShelfId={item.shelfid?.productshelfid}
                            store={item.store}
                            qtyinspected={item.qtyinspected}
                            dateReceived={item.qtycertified}
                            onClick={() => openSra(item._id)}
                            viewAtt={() => ViewAttachment(item._id)}
                          />
                        ))
                    ) : (

                      <Text textAlign={"right"} mt="32px" color="#ddd">*--No result found--*</Text>
                    )

                  )
                )

              }


            </Tbody>

          </Table>
        </TableContainer>

        <Pagination postPerpage={PostperPage} currentPage={CurrentPage} totalPosts={Data.length} paginate={paginate} />


      </Box>

      <PendingIQA isOpen={isOpen} onClose={onClose} id={SraID} state="inventoryAcc" />
      <AttachmentModal singleData={SIngleData} isOpen={OpenModal} onClose={() => setOpenModal(false)} />
    </MainLayout>
  )
}

